// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   Calendar Page – Responsive CSS (original card layout preserved)
   ========================================================= */

/* --- Container --- */
.ant-picker-calendar.ant-picker-calendar-full.full-page-calendar {
  background: transparent;
  width: 100%;
  max-width: 100%;
}

/* --- Calendar Panel Body --- */
.ant-picker-calendar.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-body {
  padding: 8px 0;
  border-radius: 10px !important;
  overflow: hidden;
}

/* --- Day Cell Borders --- */
.ant-picker-calendar.full-page-calendar td.ant-picker-cell:first-child {
  border-left: 0 !important;
}

.ant-picker-calendar.full-page-calendar td.ant-picker-cell:last-child {
  border-right: 0 !important;
}

/* --- Day Cells ---
   Use height (not min-height) on <td>: table cells treat height as a minimum
   and expand naturally when content exceeds it. */
.ant-picker-calendar.full-page-calendar td.ant-picker-cell {
  height: 170px;
  border: 1px solid rgba(0, 0, 0, 0.15) !important;
  padding: 10px 8px !important;
  vertical-align: top;
}

/* Override Ant Design's fixed 86 px cap on the content area */
.ant-picker-calendar.full-page-calendar .ant-picker-panel .ant-picker-calendar-date-content {
  height: auto !important;
  overflow-y: visible !important;
  min-height: 60px;
}

.ant-picker-calendar.full-page-calendar .ant-picker-cell-inner.ant-picker-calendar-date {
  height: auto !important;
  border: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* --- Date Number --- */
td.ant-picker-cell.ant-picker-cell-in-view .ant-picker-calendar-date-value {
  font-weight: 400;
  font-size: 11px;
  line-height: 1;
  letter-spacing: 0;
  color: #8c8c8c;
}

.ant-picker-calendar.full-page-calendar td.ant-picker-cell .ant-picker-calendar-date-value {
  font-weight: 400;
  font-size: 11px;
  line-height: 1;
  letter-spacing: 0;
  color: #bfbfbf;
}

/* --- Today / Selected State --- */
td.ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-today.ant-picker-cell-selected {
  background: linear-gradient(180deg, #E8EFF6 0%, #FFFFFF 100%) !important;
}

.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date,
.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date-today,
.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date,
.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date-today {
  background: transparent !important;
}

.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date-today .ant-picker-calendar-date-value,
.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date .ant-picker-calendar-date-value,
.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date-today .ant-picker-calendar-date-value,
.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date .ant-picker-calendar-date-value {
  color: #fff !important;
  padding: 5px;
  background: #071E31;
  margin-left: auto;
  border-radius: 50%;
  font-family: "Greycliff CF", sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 1;
  letter-spacing: 0;
  width: 26px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* --- Calendar Header --- */
.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 10px;
}

.calendar-header h2 {
  font-weight: 600;
  font-size: 25px;
  line-height: 1;
  letter-spacing: -0.11px;
  margin: 0;
}

.calendar-controls {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

/* --- Cell Content Container --- */
.calendar-cell-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

/* --- Action Buttons --- */
.calendar-today-buttons {
  display: flex;
  flex-direction: row;
  gap: 4px;
  margin-bottom: 4px;
  width: 100%;
}

button.ant-btn.post-btn-create {
  background: #3B6B94;
  color: #fff !important;
  font-weight: 500;
  font-size: 12px;
  line-height: 1;
  letter-spacing: -0.11px;
  height: 32px !important;
  border-radius: 5px !important;
  flex: 1 1;
  min-width: 0;
  padding: 0 6px !important;
  overflow: hidden;
  white-space: nowrap;
  display: flex !important;
  align-items: center;
  justify-content: center;
}

button.ant-btn.ins-btn-calender {
  background: #D7E1EB;
  color: #071E31 !important;
  font-weight: 500;
  font-size: 12px;
  line-height: 1;
  letter-spacing: -0.11px;
  height: 32px !important;
  border-radius: 5px !important;
  flex: 1 1;
  min-width: 0;
  padding: 0 6px !important;
  overflow: hidden;
  white-space: nowrap;
  display: flex !important;
  align-items: center;
  justify-content: center;
}

/* ── Creative Event Cards ── */
.calendar-card {
  border-radius: 10px;
  padding: 0;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 6px;
  background: #ffffff;
  border-left: 3px solid transparent;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.04);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.calendar-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.13), 0 0 0 1px rgba(0, 0, 0, 0.06);
}

.calendar-card:last-child { margin-bottom: 0; }
.calendar-card:active { transform: translateY(0); cursor: grabbing; }
.calendar-card[draggable="true"] { cursor: grab; }
.calendar-card[draggable="true"]:active { cursor: grabbing; transform: translateY(0); }

/* ── Card Banner (full-width top image / gradient) ── */
.cal-card-banner {
  position: relative;
  width: 100%;
  height: 68px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #a8c0e0 0%, #3b6b94 100%);
  flex-shrink: 0;
}

.cal-card-banner-media {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.cal-card-banner-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.cal-card-banner-icon {
  font-size: 26px;
  line-height: 1;
  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.25));
}

/* ── Blog tag (top-left corner) ── */
.cal-card-blog-tag {
  position: absolute;
  top: 4px;
  left: 4px;
  z-index: 2;
  font-size: 9px;
  font-weight: 700;
  color: #fff;
  background: rgba(102, 126, 234, 0.85);
  border-radius: 4px;
  padding: 2px 5px;
  letter-spacing: 0.2px;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  line-height: 1.4;
}

/* ── Post type pill (top-right corner) ── */
.cal-card-type-pill {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 2;
  font-size: 8px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.95);
  background: rgba(0, 0, 0, 0.35);
  border-radius: 4px;
  padding: 2px 5px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  line-height: 1.4;
}

/* ── Card Body ── */
.cal-card-body {
  padding: 6px 8px 8px;
}

/* ── Title ── */
.cal-card-title {
  font-size: 11px;
  font-weight: 700;
  color: #1a2332;
  line-height: 1.35;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 4px;
}

/* ── Status badge ── */
.cal-card-status {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 9px;
  font-weight: 600;
  border-radius: 5px;
  padding: 2px 6px;
  margin-top: 4px;
  border: 1px solid;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cal-card-status .anticon { font-size: 9px; flex-shrink: 0; }

/* ── Card Time (kept for legacy) ── */
.calendar-card-time {
  font-size: 9px;
  color: #6b7280;
  line-height: 1.2;
  display: flex;
  align-items: center;
  gap: 2px;
  margin-top: 2px;
}

/* ── Content Theme Chip ── */
.calendar-theme-chip {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  gap: 4px;
  border: 1px solid;
  border-radius: 999px;
  padding: 2px 6px;
  margin-top: 4px;
  font-size: 9px;
  font-weight: 600;
  line-height: 1.2;
}

.calendar-theme-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex: 0 0 auto;
}

.calendar-theme-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ── Sub-pillar Row ── */
.calendar-subpillar-row {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  margin-top: 3px;
}

.calendar-subpillar-chip,
.calendar-subpillar-more {
  max-width: 100%;
  border: 1px solid;
  border-radius: 999px;
  padding: 1px 5px;
  font-size: 9px;
  font-weight: 600;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calendar-subpillar-more {
  color: #64748b;
  border-color: #cbd5e1;
  background: #f8fafc;
}

/* --- LinkedIn Activity Card --- */
.calendar-linkedin-activity-card {
  width: 100%;
  box-sizing: border-box;
  margin-top: 7px;
  padding: 8px;
  border: 1px solid #d8e4ef;
  border-left: 3px solid #0a66c2;
  border-radius: 6px;
  background: #f7fbff;
}

.calendar-linkedin-activity-header {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  min-width: 0;
}

.calendar-linkedin-activity-icon {
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #0a66c2;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  font-family: Arial, sans-serif;
  margin-top: 1px;
}

.calendar-linkedin-activity-copy { min-width: 0; flex: 1 1; }

.calendar-linkedin-activity-copy strong {
  display: block;
  color: #123d66;
  font-size: 10.5px;
  font-weight: 700;
  line-height: 1.25;
}

.calendar-linkedin-activity-copy span {
  display: block;
  margin-top: 3px;
  color: #4f6478;
  font-size: 9.5px;
  line-height: 1.35;
}

.calendar-linkedin-activity-form {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
}

.calendar-linkedin-activity-form .ant-input-sm {
  width: 100%;
  height: 28px;
  font-size: 10px;
  border-radius: 4px;
}

.calendar-linkedin-activity-form .ant-btn-sm {
  width: 100%;
  height: 28px;
  padding: 0 10px;
  border-radius: 4px;
  font-size: 10.5px;
  font-weight: 700;
}

/* --- Misc --- */
.calendar-team {
  font-size: 12px;
  color: #555;
  word-break: break-all;
  text-wrap: auto;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.calendar-progress { font-size: 11px; margin-top: 2px; }

.calendar-status {
  margin-top: 4px;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  text-align: center;
  display: inline-block;
}

.calendar-status.review   { border: 1px solid #fa8c16; color: #fa8c16; }
.calendar-status.approved { border: 1px solid #52c41a; color: #52c41a; }
.calendar-status.published { border: 1px solid #52c41a; color: #52c41a; }
.calendar-status.delayed  { border: 1px solid #f5222d; color: #f5222d; }

.blur-effect { filter: blur(1px); }

/* --- Calendar Markings --- */
.calendar-markings-area {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-bottom: 4px;
}

.calendar-marking-strip {
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.3;
  border-left: 3px solid;
  cursor: pointer;
  transition: opacity 0.15s;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}

.calendar-marking-strip:hover { opacity: 0.85; }
.calendar-marking-strip .marking-emoji { font-size: 11px; flex-shrink: 0; }
.calendar-marking-strip .marking-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.marking-add-btn {
  background: transparent !important;
  border: 1px dashed #d9d9d9 !important;
  color: #8c8c8c !important;
  font-size: 10px !important;
  height: 22px !important;
  padding: 0 6px !important;
  border-radius: 4px !important;
  display: flex;
  align-items: center;
  gap: 3px;
  margin-bottom: 4px;
  width: 100%;
  justify-content: center;
}

.marking-add-btn:hover { border-color: #722ED1 !important; color: #722ED1 !important; }

.calendar-marking-modal-type-option { display: flex; align-items: center; gap: 8px; }
.calendar-marking-modal-type-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }

.calendar-holiday-strip { font-weight: 700 !important; letter-spacing: 0.01em; }

.marking-creator-tag {
  font-size: 8px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 1px 3px;
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.09);
  flex-shrink: 0;
  line-height: 1.3;
  margin-right: 1px;
}

.calendar-marking-strip.brand-marking { border-left-style: dashed; border-left-width: 3px; }
.calendar-marking-strip.broadcast-marking::after { content: "🌐"; font-size: 9px; margin-left: auto; flex-shrink: 0; }

/* Blog Write request card — own color (teal), distinct from markings/
   holidays, so an in-progress blog request reads apart from OOO/Travel
   strips at a glance. */
.calendar-marking-strip.blog-write-request-strip {
  background: #E6FFFB;
  border-left-color: #08979C;
  color: #08979C;
}

/* =========================================================
   Responsive Breakpoints
   ========================================================= */

/* ── ≤ 1400px: slightly tighter spacing ── */
@media (max-width: 1400px) {
  .ant-picker-calendar.full-page-calendar td.ant-picker-cell {
    padding: 8px 6px !important;
    height: 160px;
  }

  button.ant-btn.post-btn-create,
  button.ant-btn.ins-btn-calender {
    height: 28px !important;
    font-size: 11px;
    padding: 0 4px !important;
  }

  .cal-card-banner { height: 56px; }
  .cal-card-banner-icon { font-size: 22px; }
}

/* ── ≤ 1200px: reduce image and typography ── */
@media (max-width: 1200px) {
  .ant-picker-calendar.full-page-calendar td.ant-picker-cell {
    padding: 6px 5px !important;
    height: 150px;
  }

  .calendar-header h2 { font-size: 20px; }

  .cal-card-banner { height: 48px; }
  .cal-card-banner-icon { font-size: 20px; }
  .cal-card-title { font-size: 10px; }

  button.ant-btn.post-btn-create,
  button.ant-btn.ins-btn-calender {
    height: 26px !important;
    font-size: 10px;
    padding: 0 3px !important;
  }
}

/* ── ≤ 1024px: hide theme chips, tighter layout ── */
@media (max-width: 1024px) {
  .ant-picker-calendar.full-page-calendar td.ant-picker-cell {
    padding: 5px 4px !important;
    height: 135px;
  }

  .calendar-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .calendar-header h2 { font-size: 17px; }

  .cal-card-banner { height: 40px; }
  .cal-card-banner-icon { font-size: 18px; }
  .cal-card-title { font-size: 10px; }
  .cal-card-body { padding: 4px 6px 5px; }

  button.ant-btn.post-btn-create,
  button.ant-btn.ins-btn-calender {
    height: 24px !important;
    font-size: 9px;
    padding: 0 2px !important;
    gap: 2px;
  }

  .calendar-today-buttons { gap: 3px; }

  .calendar-theme-chip,
  .calendar-subpillar-row { display: none; }
}

/* ── ≤ 768px: horizontal scroll so cells never get squished ── */
@media (max-width: 768px) {
  .full-calendar-page {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .ant-picker-calendar.ant-picker-calendar-full.full-page-calendar {
    min-width: 640px;
  }

  .ant-picker-calendar.full-page-calendar td.ant-picker-cell {
    height: 110px;
    padding: 4px 3px !important;
  }

  .cal-card-banner { height: 34px; }
  .cal-card-banner-icon { font-size: 16px; }
  .cal-card-title { font-size: 10px; }
  .cal-card-type-pill, .cal-card-blog-tag { display: none; }

  button.ant-btn.post-btn-create,
  button.ant-btn.ins-btn-calender {
    height: 22px !important;
    font-size: 8px;
    padding: 0 2px !important;
  }

  .calendar-marking-strip { font-size: 8.5px; padding: 1px 4px; }
}

/* ── ≤ 480px: even more compact ── */
@media (max-width: 480px) {
  .ant-picker-calendar.ant-picker-calendar-full.full-page-calendar {
    min-width: 520px;
  }

  .ant-picker-calendar.full-page-calendar td.ant-picker-cell {
    height: 90px;
    padding: 3px 2px !important;
  }

  .calendar-header h2 { font-size: 15px; }

  .cal-card-banner { height: 28px; }
  .cal-card-banner-icon { font-size: 14px; }
}

/* ===== MOBILE CALENDAR RESPONSIVE ===== */
@media (max-width: 767px) {
  .full-calendar-page {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .ant-picker-calendar.ant-picker-calendar-full.full-page-calendar {
    min-width: 1500px;
  }

  .ant-picker-calendar.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-body {
    overflow: visible;
  }

  .ant-picker-calendar.full-page-calendar td.ant-picker-cell {
    height: 130px !important;
    padding: 6px 5px !important;
  }

  .calendar-header {
    min-width: 0;
    position: sticky;
    left: 0;
  }

  .calendar-header h2 {
    font-size: 18px !important;
  }

  .calendar-controls {
    flex-wrap: wrap;
    gap: 6px;
  }

  .calendar-controls .ant-select {
    min-width: 80px !important;
  }

  .calendar-card {
    min-height: 60px !important;
    padding: 4px !important;
  }

  .calendar-title {
    font-size: 10px !important;
  }

  .calendar-img {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
    max-width: 40px !important;
  }

  .calendar-status {
    font-size: 9px !important;
    padding: 1px 4px !important;
  }
}

/* ── Post text label row + Rewrite with AI button ── */
.post-text-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
}

.post-rewrite-ai-btn {
  font-size: 12.5px !important;
  font-weight: 600 !important;
  color: #2563eb !important;
  padding: 0 !important;
  height: auto !important;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.post-rewrite-ai-btn:hover { color: #1d4ed8 !important; }
.post-rewrite-ai-btn:disabled { color: #94a3b8 !important; }

/* ── Content Intelligence panel (post create/edit drawer) ── */
.post-ci-panel {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 18px;
  margin-bottom: 18px;
}

.post-ci-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.post-ci-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

.post-ci-subtitle {
  margin: 2px 0 0;
  font-size: 12.5px;
  color: #64748b;
}

.post-ci-analyze-btn,
.post-ci-analyze-btn.ant-btn-primary {
  flex-shrink: 0;
  border-radius: 8px !important;
  font-weight: 600 !important;
  background: linear-gradient(135deg, #2563eb, #1d4ed8) !important;
  border: none !important;
  color: #ffffff !important;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.35) !important;
  height: 38px;
  padding: 0 18px !important;
}

.post-ci-analyze-btn:hover,
.post-ci-analyze-btn.ant-btn-primary:hover,
.post-ci-analyze-btn:focus {
  background: linear-gradient(135deg, #3b82f6, #2563eb) !important;
  color: #ffffff !important;
}

.post-ci-analyze-btn:disabled,
.post-ci-analyze-btn.ant-btn-primary:disabled {
  background: #94a3b8 !important;
  color: #f1f5f9 !important;
  box-shadow: none !important;
}

.post-ci-analyze-btn .anticon { color: #ffffff !important; }

.post-ci-cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

@media (max-width: 900px) {
  .post-ci-cards {
    grid-template-columns: 1fr;
  }
}

.post-ci-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px;
  min-height: 140px;
  display: flex;
  flex-direction: column;
}

.post-ci-card-top {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.post-ci-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 13px;
}

.post-ci-label {
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #475569;
}

.post-ci-value {
  font-size: 26px;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 6px;
}

.post-ci-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 6px;
  margin-bottom: 8px;
  width: fit-content;
}

.post-ci-note {
  margin: 0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.45;
}

.post-ci-empty {
  margin: 0;
  font-size: 12.5px;
  color: #94a3b8;
  font-style: italic;
}

.post-ci-suggestion-list {
  margin: 0;
  padding-left: 16px;
  font-size: 12.5px;
  color: #334155;
  line-height: 1.5;
}

.post-ci-suggestion-list li {
  margin-bottom: 6px;
}

.post-ci-accuracy {
  display: inline-block;
  font-size: 12.5px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 8px;
  margin-bottom: 10px;
  width: fit-content;
}

.post-ci-fact-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 180px;
  overflow-y: auto;
}

.post-ci-fact-item {
  border-bottom: 1px dashed #e2e8f0;
  padding-bottom: 8px;
}

.post-ci-fact-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.post-ci-fact-claim {
  font-size: 12px;
  color: #334155;
  margin-bottom: 4px;
  line-height: 1.4;
}

.post-ci-fact-badge {
  display: inline-block;
  font-size: 10.5px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 6px;
}

/* Calendar modern parity with user panel */
.calendar-today-buttons {
  max-height: 0;
  opacity: 0;
  margin-top: 0;
  margin-bottom: 0;
  gap: 10px;
  overflow: hidden;
  pointer-events: none;
  transition: max-height 0.2s ease, opacity 0.2s ease, margin-top 0.2s ease, margin-bottom 0.2s ease;
}

.ant-picker-calendar.full-page-calendar td.ant-picker-cell:hover .ant-picker-cell-inner {
  background: transparent !important;
}

.ant-picker-calendar.full-page-calendar td.ant-picker-cell:hover .calendar-today-buttons,
.calendar-cell-content:focus-within .calendar-today-buttons {
  max-height: 40px;
  opacity: 1;
  margin-top: 16px;
  margin-bottom: 6px;
  pointer-events: auto;
}

@keyframes cal-glow-up {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes cal-today-ring {
  0% { box-shadow: 0 0 0 0 rgba(59, 107, 148, 0.6); }
  65% { box-shadow: 0 0 0 8px rgba(59, 107, 148, 0); }
  100% { box-shadow: 0 0 0 8px rgba(59, 107, 148, 0); }
}

/* overflow:visible + position:relative must apply to EVERY cell, not just
   .cal-future ones — .calendar-today-buttons (Create/Mark, shown on hover)
   reveals itself by animating max-height/margin-top, which grows the cell's
   own content beyond its resting box. With overflow staying at Ant Design's
   default (hidden) on a past-date cell — the only ones NOT matching
   :has(.cal-future) — that growth was being silently clipped: the buttons
   were genuinely there (opacity:1) and even correctly hoverable, just
   invisible. Confirmed live: a past date's cell computed \`overflow: hidden\`
   while a future date's computed \`overflow: visible\`, and only the future
   one visibly showed Create/Mark on hover. Split out so the future-only
   glow/lift decoration below stays future-only, while every cell — past,
   present, or future — can reveal its Create/Mark buttons on hover, matching
   the "past dates can create/mark too" feature this calendar already ships.
*/
.ant-picker-calendar.full-page-calendar td.ant-picker-cell {
  position: relative;
  overflow: visible;
}

.ant-picker-calendar.full-page-calendar td.ant-picker-cell:has(.cal-future) {
  transition: transform 0.28s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.28s ease,
    border-color 0.28s ease,
    background 0.28s ease;
}

.ant-picker-calendar.full-page-calendar td.ant-picker-cell:has(.cal-future)::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2.5px;
  background: linear-gradient(90deg, #3b6b94 0%, #6ce5e8 100%);
  transform: scaleX(0);
  transform-origin: left center;
  opacity: 0;
  border-radius: 2px 2px 0 0;
  transition: transform 0.32s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.18s ease;
  z-index: 3;
  pointer-events: none;
}

.ant-picker-calendar.full-page-calendar td.ant-picker-cell:has(.cal-future):hover::before {
  transform: scaleX(1);
  opacity: 1;
}

.ant-picker-calendar.full-page-calendar td.ant-picker-cell:has(.cal-future)::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse 80% 55% at 50% 110%, rgba(59, 107, 148, 0.11) 0%, transparent 70%);
  opacity: 0;
  pointer-events: none;
  z-index: 0;
  transition: opacity 0.3s ease;
}

.ant-picker-calendar.full-page-calendar td.ant-picker-cell:has(.cal-future):hover::after {
  opacity: 1;
  animation: cal-glow-up 0.3s ease both;
}

.ant-picker-calendar.full-page-calendar td.ant-picker-cell:has(.cal-future):hover {
  transform: translateY(-3px);
  background: rgba(59, 107, 148, 0.03) !important;
  border-color: rgba(59, 107, 148, 0.3) !important;
  box-shadow:
    0 1px 0 rgba(59, 107, 148, 0.14),
    0 6px 20px rgba(15, 23, 42, 0.1),
    0 2px 6px rgba(15, 23, 42, 0.06) !important;
  z-index: 2;
}

.ant-picker-calendar.full-page-calendar td.ant-picker-cell:has(.cal-future) .ant-picker-calendar-date-value {
  display: inline-block;
  transition: transform 0.3s cubic-bezier(0.34, 1.3, 0.64, 1), color 0.22s ease;
}

.ant-picker-calendar.full-page-calendar td.ant-picker-cell:has(.cal-future):hover .ant-picker-calendar-date-value {
  transform: scale(1.14);
  color: #3b6b94 !important;
}

.ant-picker-calendar.full-page-calendar td.ant-picker-cell-today:has(.cal-future) .ant-picker-calendar-date-value {
  animation: cal-today-ring 2.4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  border-radius: 50%;
}

button.ant-btn.post-btn-create {
  background: var(--brand-gradient) !important;
  border: none !important;
  border-radius: var(--r-sm) !important;
  padding: 0 10px !important;
  transition: box-shadow 0.15s var(--ease-out), transform 0.15s var(--ease-out);
}

button.ant-btn.post-btn-create:hover {
  background: var(--brand-gradient-hover) !important;
  box-shadow: var(--shadow-brand);
  transform: translateY(-1px);
}

button.ant-btn.ins-btn-calender {
  background: var(--brand-50) !important;
  color: var(--brand-700) !important;
  border: 1px solid var(--brand-100) !important;
  border-radius: var(--r-sm) !important;
  padding: 0 10px !important;
  transition: background 0.15s var(--ease-out), transform 0.15s var(--ease-out);
}

button.ant-btn.ins-btn-calender:hover {
  background: var(--brand-100) !important;
  transform: translateY(-1px);
}

.post-text-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
}
.post-rewrite-ai-btn {
  font-size: 12.5px !important;
  font-weight: 600 !important;
  color: #2563eb !important;
  padding: 0 !important;
  height: auto !important;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.post-rewrite-ai-btn:hover { color: #1d4ed8 !important; }
.post-rewrite-ai-btn:disabled { color: #94a3b8 !important; }
`, "",{"version":3,"sources":["webpack://./src/assets/styles/calendar.css"],"names":[],"mappings":"AAAA;;8DAE8D;;AAE9D,sBAAsB;AACtB;EACE,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;kDAEkD;AAClD;EACE,aAAa;EACb,gDAAgD;EAChD,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,wEAAwE;AAC1E;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;EAIE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,wEAAwE;EACxE,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,yEAAyE;AAC3E;;AAEA,4BAA4B,gBAAgB,EAAE;AAC9C,wBAAwB,wBAAwB,EAAE,gBAAgB,EAAE;AACpE,mCAAmC,YAAY,EAAE;AACjD,0CAA0C,gBAAgB,EAAE,wBAAwB,EAAE;;AAEtF,wDAAwD;AACxD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kDAAkD;AACpD;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,4BAA4B,cAAc,EAAE,cAAc,EAAE;;AAE5D,sCAAsC;AACtC;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,mCAAmC,YAAY,EAAE,SAAO,EAAE;;AAE1D;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,qBAAqB,eAAe,EAAE,eAAe,EAAE;;AAEvD;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,4BAA4B,yBAAyB,EAAE,cAAc,EAAE;AACvE,4BAA4B,yBAAyB,EAAE,cAAc,EAAE;AACvE,6BAA6B,yBAAyB,EAAE,cAAc,EAAE;AACxE,4BAA4B,yBAAyB,EAAE,cAAc,EAAE;;AAEvE,eAAe,iBAAiB,EAAE;;AAElC,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,gCAAgC,aAAa,EAAE;AAC/C,yCAAyC,eAAe,EAAE,cAAc,EAAE;AAC1E;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,uBAAuB;AACzB;;AAEA,yBAAyB,gCAAgC,EAAE,yBAAyB,EAAE;;AAEtF,sCAAsC,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACpF,mCAAmC,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc,EAAE;;AAElG,0BAA0B,2BAA2B,EAAE,sBAAsB,EAAE;;AAE/E;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,wCAAwC,yBAAyB,EAAE,sBAAsB,EAAE;AAC3F,mDAAmD,aAAa,EAAE,cAAc,EAAE,iBAAiB,EAAE,cAAc,EAAE;;AAErH;;wBAEwB;AACxB;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;8DAE8D;;AAE9D,6CAA6C;AAC7C;EACE;IACE,2BAA2B;IAC3B,aAAa;EACf;;EAEA;;IAEE,uBAAuB;IACvB,eAAe;IACf,yBAAyB;EAC3B;;EAEA,mBAAmB,YAAY,EAAE;EACjC,wBAAwB,eAAe,EAAE;AAC3C;;AAEA,gDAAgD;AAChD;EACE;IACE,2BAA2B;IAC3B,aAAa;EACf;;EAEA,sBAAsB,eAAe,EAAE;;EAEvC,mBAAmB,YAAY,EAAE;EACjC,wBAAwB,eAAe,EAAE;EACzC,kBAAkB,eAAe,EAAE;;EAEnC;;IAEE,uBAAuB;IACvB,eAAe;IACf,yBAAyB;EAC3B;AACF;;AAEA,qDAAqD;AACrD;EACE;IACE,2BAA2B;IAC3B,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA,sBAAsB,eAAe,EAAE;;EAEvC,mBAAmB,YAAY,EAAE;EACjC,wBAAwB,eAAe,EAAE;EACzC,kBAAkB,eAAe,EAAE;EACnC,iBAAiB,oBAAoB,EAAE;;EAEvC;;IAEE,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,QAAQ;EACV;;EAEA,0BAA0B,QAAQ,EAAE;;EAEpC;4BAC0B,aAAa,EAAE;AAC3C;;AAEA,iEAAiE;AACjE;EACE;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,2BAA2B;EAC7B;;EAEA,mBAAmB,YAAY,EAAE;EACjC,wBAAwB,eAAe,EAAE;EACzC,kBAAkB,eAAe,EAAE;EACnC,0CAA0C,aAAa,EAAE;;EAEzD;;IAEE,uBAAuB;IACvB,cAAc;IACd,yBAAyB;EAC3B;;EAEA,0BAA0B,gBAAgB,EAAE,gBAAgB,EAAE;AAChE;;AAEA,qCAAqC;AACrC;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA,sBAAsB,eAAe,EAAE;;EAEvC,mBAAmB,YAAY,EAAE;EACjC,wBAAwB,eAAe,EAAE;AAC3C;;AAEA,2CAA2C;AAC3C;EACE;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,OAAO;EACT;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;AACF;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,6BAA6B,yBAAyB,EAAE;AACxD,gCAAgC,yBAAyB,EAAE;;AAE3D,+DAA+D;AAC/D;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,2BAA2B;EAC3B,gEAAgE;EAChE,uBAAuB;EACvB,yBAAyB;EACzB,wDAAwD;EACxD,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;;;EAGE,gEAAgE;EAChE,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,gCAAgC,yBAAyB,EAAE;;AAE3D;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,kGAAkG;AACpG;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,KAAK,2CAA2C,EAAE;EAClD,MAAM,2CAA2C,EAAE;EACnD,OAAO,2CAA2C,EAAE;AACtD;;AAEA;;;;;;;;;;;;;CAaC;AACD;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;;;yBAGuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,4DAA4D;EAC5D,oBAAoB;EACpB,6BAA6B;EAC7B,UAAU;EACV,0BAA0B;EAC1B,8EAA8E;EAC9E,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sGAAsG;EACtG,UAAU;EACV,oBAAoB;EACpB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,gDAAgD;EAChD;;;+CAG6C;EAC7C,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,6EAA6E;AAC/E;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oEAAoE;EACpE,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,qCAAqC;EACrC,0BAA0B;EAC1B,6EAA6E;AAC/E;;AAEA;EACE,kDAAkD;EAClD,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,6CAA6C;EAC7C,qCAAqC;EACrC,0BAA0B;EAC1B,6EAA6E;AAC/E;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;AACX;AACA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA,6BAA6B,yBAAyB,EAAE;AACxD,gCAAgC,yBAAyB,EAAE","sourcesContent":["/* =========================================================\n   Calendar Page – Responsive CSS (original card layout preserved)\n   ========================================================= */\n\n/* --- Container --- */\n.ant-picker-calendar.ant-picker-calendar-full.full-page-calendar {\n  background: transparent;\n  width: 100%;\n  max-width: 100%;\n}\n\n/* --- Calendar Panel Body --- */\n.ant-picker-calendar.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-body {\n  padding: 8px 0;\n  border-radius: 10px !important;\n  overflow: hidden;\n}\n\n/* --- Day Cell Borders --- */\n.ant-picker-calendar.full-page-calendar td.ant-picker-cell:first-child {\n  border-left: 0 !important;\n}\n\n.ant-picker-calendar.full-page-calendar td.ant-picker-cell:last-child {\n  border-right: 0 !important;\n}\n\n/* --- Day Cells ---\n   Use height (not min-height) on <td>: table cells treat height as a minimum\n   and expand naturally when content exceeds it. */\n.ant-picker-calendar.full-page-calendar td.ant-picker-cell {\n  height: 170px;\n  border: 1px solid rgba(0, 0, 0, 0.15) !important;\n  padding: 10px 8px !important;\n  vertical-align: top;\n}\n\n/* Override Ant Design's fixed 86 px cap on the content area */\n.ant-picker-calendar.full-page-calendar .ant-picker-panel .ant-picker-calendar-date-content {\n  height: auto !important;\n  overflow-y: visible !important;\n  min-height: 60px;\n}\n\n.ant-picker-calendar.full-page-calendar .ant-picker-cell-inner.ant-picker-calendar-date {\n  height: auto !important;\n  border: 0 !important;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n/* --- Date Number --- */\ntd.ant-picker-cell.ant-picker-cell-in-view .ant-picker-calendar-date-value {\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 1;\n  letter-spacing: 0;\n  color: #8c8c8c;\n}\n\n.ant-picker-calendar.full-page-calendar td.ant-picker-cell .ant-picker-calendar-date-value {\n  font-weight: 400;\n  font-size: 11px;\n  line-height: 1;\n  letter-spacing: 0;\n  color: #bfbfbf;\n}\n\n/* --- Today / Selected State --- */\ntd.ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-today.ant-picker-cell-selected {\n  background: linear-gradient(180deg, #E8EFF6 0%, #FFFFFF 100%) !important;\n}\n\n.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date,\n.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date-today,\n.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date,\n.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date-today {\n  background: transparent !important;\n}\n\n.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date-today .ant-picker-calendar-date-value,\n.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-cell-selected .ant-picker-calendar-date .ant-picker-calendar-date-value,\n.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date-today .ant-picker-calendar-date-value,\n.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-cell-selected:hover .ant-picker-calendar-date .ant-picker-calendar-date-value {\n  color: #fff !important;\n  padding: 5px;\n  background: #071E31;\n  margin-left: auto;\n  border-radius: 50%;\n  font-family: \"Greycliff CF\", sans-serif;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 1;\n  letter-spacing: 0;\n  width: 26px;\n  height: 26px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* --- Calendar Header --- */\n.calendar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.calendar-header h2 {\n  font-weight: 600;\n  font-size: 25px;\n  line-height: 1;\n  letter-spacing: -0.11px;\n  margin: 0;\n}\n\n.calendar-controls {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n/* --- Cell Content Container --- */\n.calendar-cell-content {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n/* --- Action Buttons --- */\n.calendar-today-buttons {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  margin-bottom: 4px;\n  width: 100%;\n}\n\nbutton.ant-btn.post-btn-create {\n  background: #3B6B94;\n  color: #fff !important;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 1;\n  letter-spacing: -0.11px;\n  height: 32px !important;\n  border-radius: 5px !important;\n  flex: 1;\n  min-width: 0;\n  padding: 0 6px !important;\n  overflow: hidden;\n  white-space: nowrap;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\nbutton.ant-btn.ins-btn-calender {\n  background: #D7E1EB;\n  color: #071E31 !important;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 1;\n  letter-spacing: -0.11px;\n  height: 32px !important;\n  border-radius: 5px !important;\n  flex: 1;\n  min-width: 0;\n  padding: 0 6px !important;\n  overflow: hidden;\n  white-space: nowrap;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ── Creative Event Cards ── */\n.calendar-card {\n  border-radius: 10px;\n  padding: 0;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  width: 100%;\n  box-sizing: border-box;\n  margin-bottom: 6px;\n  background: #ffffff;\n  border-left: 3px solid transparent;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.04);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.calendar-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.13), 0 0 0 1px rgba(0, 0, 0, 0.06);\n}\n\n.calendar-card:last-child { margin-bottom: 0; }\n.calendar-card:active { transform: translateY(0); cursor: grabbing; }\n.calendar-card[draggable=\"true\"] { cursor: grab; }\n.calendar-card[draggable=\"true\"]:active { cursor: grabbing; transform: translateY(0); }\n\n/* ── Card Banner (full-width top image / gradient) ── */\n.cal-card-banner {\n  position: relative;\n  width: 100%;\n  height: 68px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #a8c0e0 0%, #3b6b94 100%);\n  flex-shrink: 0;\n}\n\n.cal-card-banner-media {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.cal-card-banner-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.cal-card-banner-icon {\n  font-size: 26px;\n  line-height: 1;\n  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.25));\n}\n\n/* ── Blog tag (top-left corner) ── */\n.cal-card-blog-tag {\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  z-index: 2;\n  font-size: 9px;\n  font-weight: 700;\n  color: #fff;\n  background: rgba(102, 126, 234, 0.85);\n  border-radius: 4px;\n  padding: 2px 5px;\n  letter-spacing: 0.2px;\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n  line-height: 1.4;\n}\n\n/* ── Post type pill (top-right corner) ── */\n.cal-card-type-pill {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  z-index: 2;\n  font-size: 8px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.95);\n  background: rgba(0, 0, 0, 0.35);\n  border-radius: 4px;\n  padding: 2px 5px;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n  line-height: 1.4;\n}\n\n/* ── Card Body ── */\n.cal-card-body {\n  padding: 6px 8px 8px;\n}\n\n/* ── Title ── */\n.cal-card-title {\n  font-size: 11px;\n  font-weight: 700;\n  color: #1a2332;\n  line-height: 1.35;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  margin-bottom: 4px;\n}\n\n/* ── Status badge ── */\n.cal-card-status {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 9px;\n  font-weight: 600;\n  border-radius: 5px;\n  padding: 2px 6px;\n  margin-top: 4px;\n  border: 1px solid;\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cal-card-status .anticon { font-size: 9px; flex-shrink: 0; }\n\n/* ── Card Time (kept for legacy) ── */\n.calendar-card-time {\n  font-size: 9px;\n  color: #6b7280;\n  line-height: 1.2;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  margin-top: 2px;\n}\n\n/* ── Content Theme Chip ── */\n.calendar-theme-chip {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  gap: 4px;\n  border: 1px solid;\n  border-radius: 999px;\n  padding: 2px 6px;\n  margin-top: 4px;\n  font-size: 9px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.calendar-theme-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  flex: 0 0 auto;\n}\n\n.calendar-theme-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ── Sub-pillar Row ── */\n.calendar-subpillar-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n  margin-top: 3px;\n}\n\n.calendar-subpillar-chip,\n.calendar-subpillar-more {\n  max-width: 100%;\n  border: 1px solid;\n  border-radius: 999px;\n  padding: 1px 5px;\n  font-size: 9px;\n  font-weight: 600;\n  line-height: 1.3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.calendar-subpillar-more {\n  color: #64748b;\n  border-color: #cbd5e1;\n  background: #f8fafc;\n}\n\n/* --- LinkedIn Activity Card --- */\n.calendar-linkedin-activity-card {\n  width: 100%;\n  box-sizing: border-box;\n  margin-top: 7px;\n  padding: 8px;\n  border: 1px solid #d8e4ef;\n  border-left: 3px solid #0a66c2;\n  border-radius: 6px;\n  background: #f7fbff;\n}\n\n.calendar-linkedin-activity-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 7px;\n  min-width: 0;\n}\n\n.calendar-linkedin-activity-icon {\n  flex: 0 0 16px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #0a66c2;\n  color: #ffffff;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 16px;\n  text-align: center;\n  font-family: Arial, sans-serif;\n  margin-top: 1px;\n}\n\n.calendar-linkedin-activity-copy { min-width: 0; flex: 1; }\n\n.calendar-linkedin-activity-copy strong {\n  display: block;\n  color: #123d66;\n  font-size: 10.5px;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.calendar-linkedin-activity-copy span {\n  display: block;\n  margin-top: 3px;\n  color: #4f6478;\n  font-size: 9.5px;\n  line-height: 1.35;\n}\n\n.calendar-linkedin-activity-form {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.calendar-linkedin-activity-form .ant-input-sm {\n  width: 100%;\n  height: 28px;\n  font-size: 10px;\n  border-radius: 4px;\n}\n\n.calendar-linkedin-activity-form .ant-btn-sm {\n  width: 100%;\n  height: 28px;\n  padding: 0 10px;\n  border-radius: 4px;\n  font-size: 10.5px;\n  font-weight: 700;\n}\n\n/* --- Misc --- */\n.calendar-team {\n  font-size: 12px;\n  color: #555;\n  word-break: break-all;\n  text-wrap: auto;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.calendar-progress { font-size: 11px; margin-top: 2px; }\n\n.calendar-status {\n  margin-top: 4px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  text-align: center;\n  display: inline-block;\n}\n\n.calendar-status.review   { border: 1px solid #fa8c16; color: #fa8c16; }\n.calendar-status.approved { border: 1px solid #52c41a; color: #52c41a; }\n.calendar-status.published { border: 1px solid #52c41a; color: #52c41a; }\n.calendar-status.delayed  { border: 1px solid #f5222d; color: #f5222d; }\n\n.blur-effect { filter: blur(1px); }\n\n/* --- Calendar Markings --- */\n.calendar-markings-area {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  margin-bottom: 4px;\n}\n\n.calendar-marking-strip {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  border-radius: 4px;\n  padding: 2px 6px;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 1.3;\n  border-left: 3px solid;\n  cursor: pointer;\n  transition: opacity 0.15s;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.calendar-marking-strip:hover { opacity: 0.85; }\n.calendar-marking-strip .marking-emoji { font-size: 11px; flex-shrink: 0; }\n.calendar-marking-strip .marking-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.marking-add-btn {\n  background: transparent !important;\n  border: 1px dashed #d9d9d9 !important;\n  color: #8c8c8c !important;\n  font-size: 10px !important;\n  height: 22px !important;\n  padding: 0 6px !important;\n  border-radius: 4px !important;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  margin-bottom: 4px;\n  width: 100%;\n  justify-content: center;\n}\n\n.marking-add-btn:hover { border-color: #722ED1 !important; color: #722ED1 !important; }\n\n.calendar-marking-modal-type-option { display: flex; align-items: center; gap: 8px; }\n.calendar-marking-modal-type-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }\n\n.calendar-holiday-strip { font-weight: 700 !important; letter-spacing: 0.01em; }\n\n.marking-creator-tag {\n  font-size: 8px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 1px 3px;\n  border-radius: 2px;\n  background: rgba(0, 0, 0, 0.09);\n  flex-shrink: 0;\n  line-height: 1.3;\n  margin-right: 1px;\n}\n\n.calendar-marking-strip.brand-marking { border-left-style: dashed; border-left-width: 3px; }\n.calendar-marking-strip.broadcast-marking::after { content: \"🌐\"; font-size: 9px; margin-left: auto; flex-shrink: 0; }\n\n/* Blog Write request card — own color (teal), distinct from markings/\n   holidays, so an in-progress blog request reads apart from OOO/Travel\n   strips at a glance. */\n.calendar-marking-strip.blog-write-request-strip {\n  background: #E6FFFB;\n  border-left-color: #08979C;\n  color: #08979C;\n}\n\n/* =========================================================\n   Responsive Breakpoints\n   ========================================================= */\n\n/* ── ≤ 1400px: slightly tighter spacing ── */\n@media (max-width: 1400px) {\n  .ant-picker-calendar.full-page-calendar td.ant-picker-cell {\n    padding: 8px 6px !important;\n    height: 160px;\n  }\n\n  button.ant-btn.post-btn-create,\n  button.ant-btn.ins-btn-calender {\n    height: 28px !important;\n    font-size: 11px;\n    padding: 0 4px !important;\n  }\n\n  .cal-card-banner { height: 56px; }\n  .cal-card-banner-icon { font-size: 22px; }\n}\n\n/* ── ≤ 1200px: reduce image and typography ── */\n@media (max-width: 1200px) {\n  .ant-picker-calendar.full-page-calendar td.ant-picker-cell {\n    padding: 6px 5px !important;\n    height: 150px;\n  }\n\n  .calendar-header h2 { font-size: 20px; }\n\n  .cal-card-banner { height: 48px; }\n  .cal-card-banner-icon { font-size: 20px; }\n  .cal-card-title { font-size: 10px; }\n\n  button.ant-btn.post-btn-create,\n  button.ant-btn.ins-btn-calender {\n    height: 26px !important;\n    font-size: 10px;\n    padding: 0 3px !important;\n  }\n}\n\n/* ── ≤ 1024px: hide theme chips, tighter layout ── */\n@media (max-width: 1024px) {\n  .ant-picker-calendar.full-page-calendar td.ant-picker-cell {\n    padding: 5px 4px !important;\n    height: 135px;\n  }\n\n  .calendar-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .calendar-header h2 { font-size: 17px; }\n\n  .cal-card-banner { height: 40px; }\n  .cal-card-banner-icon { font-size: 18px; }\n  .cal-card-title { font-size: 10px; }\n  .cal-card-body { padding: 4px 6px 5px; }\n\n  button.ant-btn.post-btn-create,\n  button.ant-btn.ins-btn-calender {\n    height: 24px !important;\n    font-size: 9px;\n    padding: 0 2px !important;\n    gap: 2px;\n  }\n\n  .calendar-today-buttons { gap: 3px; }\n\n  .calendar-theme-chip,\n  .calendar-subpillar-row { display: none; }\n}\n\n/* ── ≤ 768px: horizontal scroll so cells never get squished ── */\n@media (max-width: 768px) {\n  .full-calendar-page {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .ant-picker-calendar.ant-picker-calendar-full.full-page-calendar {\n    min-width: 640px;\n  }\n\n  .ant-picker-calendar.full-page-calendar td.ant-picker-cell {\n    height: 110px;\n    padding: 4px 3px !important;\n  }\n\n  .cal-card-banner { height: 34px; }\n  .cal-card-banner-icon { font-size: 16px; }\n  .cal-card-title { font-size: 10px; }\n  .cal-card-type-pill, .cal-card-blog-tag { display: none; }\n\n  button.ant-btn.post-btn-create,\n  button.ant-btn.ins-btn-calender {\n    height: 22px !important;\n    font-size: 8px;\n    padding: 0 2px !important;\n  }\n\n  .calendar-marking-strip { font-size: 8.5px; padding: 1px 4px; }\n}\n\n/* ── ≤ 480px: even more compact ── */\n@media (max-width: 480px) {\n  .ant-picker-calendar.ant-picker-calendar-full.full-page-calendar {\n    min-width: 520px;\n  }\n\n  .ant-picker-calendar.full-page-calendar td.ant-picker-cell {\n    height: 90px;\n    padding: 3px 2px !important;\n  }\n\n  .calendar-header h2 { font-size: 15px; }\n\n  .cal-card-banner { height: 28px; }\n  .cal-card-banner-icon { font-size: 14px; }\n}\n\n/* ===== MOBILE CALENDAR RESPONSIVE ===== */\n@media (max-width: 767px) {\n  .full-calendar-page {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .ant-picker-calendar.ant-picker-calendar-full.full-page-calendar {\n    min-width: 1500px;\n  }\n\n  .ant-picker-calendar.ant-picker-calendar-full.full-page-calendar .ant-picker-panel .ant-picker-body {\n    overflow: visible;\n  }\n\n  .ant-picker-calendar.full-page-calendar td.ant-picker-cell {\n    height: 130px !important;\n    padding: 6px 5px !important;\n  }\n\n  .calendar-header {\n    min-width: 0;\n    position: sticky;\n    left: 0;\n  }\n\n  .calendar-header h2 {\n    font-size: 18px !important;\n  }\n\n  .calendar-controls {\n    flex-wrap: wrap;\n    gap: 6px;\n  }\n\n  .calendar-controls .ant-select {\n    min-width: 80px !important;\n  }\n\n  .calendar-card {\n    min-height: 60px !important;\n    padding: 4px !important;\n  }\n\n  .calendar-title {\n    font-size: 10px !important;\n  }\n\n  .calendar-img {\n    width: 40px !important;\n    height: 40px !important;\n    min-width: 40px !important;\n    max-width: 40px !important;\n  }\n\n  .calendar-status {\n    font-size: 9px !important;\n    padding: 1px 4px !important;\n  }\n}\n\n/* ── Post text label row + Rewrite with AI button ── */\n.post-text-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 10px;\n}\n\n.post-rewrite-ai-btn {\n  font-size: 12.5px !important;\n  font-weight: 600 !important;\n  color: #2563eb !important;\n  padding: 0 !important;\n  height: auto !important;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.post-rewrite-ai-btn:hover { color: #1d4ed8 !important; }\n.post-rewrite-ai-btn:disabled { color: #94a3b8 !important; }\n\n/* ── Content Intelligence panel (post create/edit drawer) ── */\n.post-ci-panel {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 18px;\n  margin-bottom: 18px;\n}\n\n.post-ci-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.post-ci-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.post-ci-subtitle {\n  margin: 2px 0 0;\n  font-size: 12.5px;\n  color: #64748b;\n}\n\n.post-ci-analyze-btn,\n.post-ci-analyze-btn.ant-btn-primary {\n  flex-shrink: 0;\n  border-radius: 8px !important;\n  font-weight: 600 !important;\n  background: linear-gradient(135deg, #2563eb, #1d4ed8) !important;\n  border: none !important;\n  color: #ffffff !important;\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.35) !important;\n  height: 38px;\n  padding: 0 18px !important;\n}\n\n.post-ci-analyze-btn:hover,\n.post-ci-analyze-btn.ant-btn-primary:hover,\n.post-ci-analyze-btn:focus {\n  background: linear-gradient(135deg, #3b82f6, #2563eb) !important;\n  color: #ffffff !important;\n}\n\n.post-ci-analyze-btn:disabled,\n.post-ci-analyze-btn.ant-btn-primary:disabled {\n  background: #94a3b8 !important;\n  color: #f1f5f9 !important;\n  box-shadow: none !important;\n}\n\n.post-ci-analyze-btn .anticon { color: #ffffff !important; }\n\n.post-ci-cards {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n@media (max-width: 900px) {\n  .post-ci-cards {\n    grid-template-columns: 1fr;\n  }\n}\n\n.post-ci-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 14px;\n  min-height: 140px;\n  display: flex;\n  flex-direction: column;\n}\n\n.post-ci-card-top {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.post-ci-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 13px;\n}\n\n.post-ci-label {\n  font-size: 11.5px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  color: #475569;\n}\n\n.post-ci-value {\n  font-size: 26px;\n  font-weight: 800;\n  line-height: 1.1;\n  margin-bottom: 6px;\n}\n\n.post-ci-badge {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  padding: 2px 8px;\n  border-radius: 6px;\n  margin-bottom: 8px;\n  width: fit-content;\n}\n\n.post-ci-note {\n  margin: 0;\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.45;\n}\n\n.post-ci-empty {\n  margin: 0;\n  font-size: 12.5px;\n  color: #94a3b8;\n  font-style: italic;\n}\n\n.post-ci-suggestion-list {\n  margin: 0;\n  padding-left: 16px;\n  font-size: 12.5px;\n  color: #334155;\n  line-height: 1.5;\n}\n\n.post-ci-suggestion-list li {\n  margin-bottom: 6px;\n}\n\n.post-ci-accuracy {\n  display: inline-block;\n  font-size: 12.5px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 8px;\n  margin-bottom: 10px;\n  width: fit-content;\n}\n\n.post-ci-fact-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 180px;\n  overflow-y: auto;\n}\n\n.post-ci-fact-item {\n  border-bottom: 1px dashed #e2e8f0;\n  padding-bottom: 8px;\n}\n\n.post-ci-fact-item:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.post-ci-fact-claim {\n  font-size: 12px;\n  color: #334155;\n  margin-bottom: 4px;\n  line-height: 1.4;\n}\n\n.post-ci-fact-badge {\n  display: inline-block;\n  font-size: 10.5px;\n  font-weight: 700;\n  padding: 2px 7px;\n  border-radius: 6px;\n}\n\n/* Calendar modern parity with user panel */\n.calendar-today-buttons {\n  max-height: 0;\n  opacity: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  gap: 10px;\n  overflow: hidden;\n  pointer-events: none;\n  transition: max-height 0.2s ease, opacity 0.2s ease, margin-top 0.2s ease, margin-bottom 0.2s ease;\n}\n\n.ant-picker-calendar.full-page-calendar td.ant-picker-cell:hover .ant-picker-cell-inner {\n  background: transparent !important;\n}\n\n.ant-picker-calendar.full-page-calendar td.ant-picker-cell:hover .calendar-today-buttons,\n.calendar-cell-content:focus-within .calendar-today-buttons {\n  max-height: 40px;\n  opacity: 1;\n  margin-top: 16px;\n  margin-bottom: 6px;\n  pointer-events: auto;\n}\n\n@keyframes cal-glow-up {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes cal-today-ring {\n  0% { box-shadow: 0 0 0 0 rgba(59, 107, 148, 0.6); }\n  65% { box-shadow: 0 0 0 8px rgba(59, 107, 148, 0); }\n  100% { box-shadow: 0 0 0 8px rgba(59, 107, 148, 0); }\n}\n\n/* overflow:visible + position:relative must apply to EVERY cell, not just\n   .cal-future ones — .calendar-today-buttons (Create/Mark, shown on hover)\n   reveals itself by animating max-height/margin-top, which grows the cell's\n   own content beyond its resting box. With overflow staying at Ant Design's\n   default (hidden) on a past-date cell — the only ones NOT matching\n   :has(.cal-future) — that growth was being silently clipped: the buttons\n   were genuinely there (opacity:1) and even correctly hoverable, just\n   invisible. Confirmed live: a past date's cell computed `overflow: hidden`\n   while a future date's computed `overflow: visible`, and only the future\n   one visibly showed Create/Mark on hover. Split out so the future-only\n   glow/lift decoration below stays future-only, while every cell — past,\n   present, or future — can reveal its Create/Mark buttons on hover, matching\n   the \"past dates can create/mark too\" feature this calendar already ships.\n*/\n.ant-picker-calendar.full-page-calendar td.ant-picker-cell {\n  position: relative;\n  overflow: visible;\n}\n\n.ant-picker-calendar.full-page-calendar td.ant-picker-cell:has(.cal-future) {\n  transition: transform 0.28s cubic-bezier(0.22, 1, 0.36, 1),\n    box-shadow 0.28s ease,\n    border-color 0.28s ease,\n    background 0.28s ease;\n}\n\n.ant-picker-calendar.full-page-calendar td.ant-picker-cell:has(.cal-future)::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2.5px;\n  background: linear-gradient(90deg, #3b6b94 0%, #6ce5e8 100%);\n  transform: scaleX(0);\n  transform-origin: left center;\n  opacity: 0;\n  border-radius: 2px 2px 0 0;\n  transition: transform 0.32s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.18s ease;\n  z-index: 3;\n  pointer-events: none;\n}\n\n.ant-picker-calendar.full-page-calendar td.ant-picker-cell:has(.cal-future):hover::before {\n  transform: scaleX(1);\n  opacity: 1;\n}\n\n.ant-picker-calendar.full-page-calendar td.ant-picker-cell:has(.cal-future)::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(ellipse 80% 55% at 50% 110%, rgba(59, 107, 148, 0.11) 0%, transparent 70%);\n  opacity: 0;\n  pointer-events: none;\n  z-index: 0;\n  transition: opacity 0.3s ease;\n}\n\n.ant-picker-calendar.full-page-calendar td.ant-picker-cell:has(.cal-future):hover::after {\n  opacity: 1;\n  animation: cal-glow-up 0.3s ease both;\n}\n\n.ant-picker-calendar.full-page-calendar td.ant-picker-cell:has(.cal-future):hover {\n  transform: translateY(-3px);\n  background: rgba(59, 107, 148, 0.03) !important;\n  border-color: rgba(59, 107, 148, 0.3) !important;\n  box-shadow:\n    0 1px 0 rgba(59, 107, 148, 0.14),\n    0 6px 20px rgba(15, 23, 42, 0.1),\n    0 2px 6px rgba(15, 23, 42, 0.06) !important;\n  z-index: 2;\n}\n\n.ant-picker-calendar.full-page-calendar td.ant-picker-cell:has(.cal-future) .ant-picker-calendar-date-value {\n  display: inline-block;\n  transition: transform 0.3s cubic-bezier(0.34, 1.3, 0.64, 1), color 0.22s ease;\n}\n\n.ant-picker-calendar.full-page-calendar td.ant-picker-cell:has(.cal-future):hover .ant-picker-calendar-date-value {\n  transform: scale(1.14);\n  color: #3b6b94 !important;\n}\n\n.ant-picker-calendar.full-page-calendar td.ant-picker-cell-today:has(.cal-future) .ant-picker-calendar-date-value {\n  animation: cal-today-ring 2.4s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  border-radius: 50%;\n}\n\nbutton.ant-btn.post-btn-create {\n  background: var(--brand-gradient) !important;\n  border: none !important;\n  border-radius: var(--r-sm) !important;\n  padding: 0 10px !important;\n  transition: box-shadow 0.15s var(--ease-out), transform 0.15s var(--ease-out);\n}\n\nbutton.ant-btn.post-btn-create:hover {\n  background: var(--brand-gradient-hover) !important;\n  box-shadow: var(--shadow-brand);\n  transform: translateY(-1px);\n}\n\nbutton.ant-btn.ins-btn-calender {\n  background: var(--brand-50) !important;\n  color: var(--brand-700) !important;\n  border: 1px solid var(--brand-100) !important;\n  border-radius: var(--r-sm) !important;\n  padding: 0 10px !important;\n  transition: background 0.15s var(--ease-out), transform 0.15s var(--ease-out);\n}\n\nbutton.ant-btn.ins-btn-calender:hover {\n  background: var(--brand-100) !important;\n  transform: translateY(-1px);\n}\n\n.post-text-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 10px;\n}\n.post-rewrite-ai-btn {\n  font-size: 12.5px !important;\n  font-weight: 600 !important;\n  color: #2563eb !important;\n  padding: 0 !important;\n  height: auto !important;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n.post-rewrite-ai-btn:hover { color: #1d4ed8 !important; }\n.post-rewrite-ai-btn:disabled { color: #94a3b8 !important; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
